import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {NetworkCalls} from "../../NetworkCalls";
import {UserCatchReport} from "../../dtos/UserCatchReport";

export default function EditCatchReportView() {
    const { catchReportId } = useParams<{ catchReportId: string }>();
    const navigate = useNavigate();

    const [report, setReport] = useState<UserCatchReport | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!catchReportId) return;

        NetworkCalls.getCatchReportById(catchReportId)
            .then((data) => setReport(data))
            .catch(() => setError("Fehler beim Laden der Fangmeldung."))
            .finally(() => setLoading(false));
    }, [catchReportId]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        if (!report) return;
        const { name, value } = e.target;

        let newValue: any = value;
        if (name === "fishLength" || name === "fishWeight") {
            newValue = parseFloat(value);
        }
        if (name === "wasTaken") {
            newValue = value === "true" ? true : value === "false" ? false : null;
        }

        setReport({ ...report, [name]: newValue });
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!report) return;
        setLoading(true);
        NetworkCalls.updateCatchReport(report).then(() => navigate(-1)).finally(() => setLoading(false));
    };

    if (loading) return <p>Lade...</p>;
    if (error) return <p className="text-danger">{error}</p>;
    if (!report) return null;

    return (
        <div className="container mt-4">
            <h2>Fangmeldung bearbeiten</h2>
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label className="form-label">Fischart</label>
                    <input
                        className="form-control"
                        type="text"
                        name="fishName"
                        value={report.fishName}
                        onChange={handleChange}
                        disabled={true}
                    />
                </div>
                <div className="mb-3">
                    <label className="form-label">Länge (cm)</label>
                    <input
                        className="form-control"
                        type="number"
                        name="fishLength"
                        value={report.fishLength}
                        onChange={handleChange}
                    />
                </div>
                <div className="mb-3">
                    <label className="form-label">Gefangen am</label>
                    <input
                        className="form-control"
                        type="datetime-local"
                        name="catchTime"
                        value={new Date(report.catchTime - new Date(report.catchTime).getTimezoneOffset() * 60000)
                            .toISOString()
                            .slice(0, 16)}
                        onChange={handleChange}
                        disabled={true}
                    />
                </div>
                <div className="mb-3">
                    <label className="form-label">Entnommen?</label>
                    <select
                        className="form-select"
                        name="wasTaken"
                        value={report.wasTaken === null ? "unknown" : report.wasTaken.toString()}
                        onChange={handleChange}
                    >
                        <option value="unknown">Unbekannt</option>
                        <option value="true">Ja</option>
                        <option value="false">Nein</option>
                    </select>
                </div>
                <button type="submit" className="btn btn-primary">
                    Speichern
                </button>
            </form>
        </div>
    );
}